(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sadsloth-purchase-assurance"] && !Shopify.designMode) return;
  try {
    class SadslothPurchaseAssurance extends HTMLElement {
    connectedCallback() {
      this.update();
      this.timer = window.setInterval(() => this.update(), 60000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    getStoreParts(date) {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: this.dataset.timeZone || 'America/Matamoros',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hourCycle: 'h23'
      });
      return Object.fromEntries(formatter.formatToParts(date).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
    }

    update() {
      const now = new Date();
      const parts = this.getStoreParts(now);
      const secondsNow = parts.hour * 3600 + parts.minute * 60 + parts.second;
      const remaining = 86400 - secondsNow;
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const countdown = this.querySelector('[data-countdown]');
      if (countdown) countdown.textContent = hours + 'H ' + String(minutes).padStart(2, '0') + 'M';

      const orderDate = new Date(parts.year, parts.month - 1, parts.day);
      orderDate.setDate(orderDate.getDate() + Number(this.dataset.deliveryDays || 5));
      if (orderDate.getDay() === 0) orderDate.setDate(orderDate.getDate() + 1);
      const delivery = this.querySelector('[data-delivery-date]');
      if (delivery) {
        const weekdays = ['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'];
        const months = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
        delivery.textContent = weekdays[orderDate.getDay()] + ' ' + orderDate.getDate() + ' ' + months[orderDate.getMonth()];
      }
    }
  }

  if (!customElements.get('sadsloth-purchase-assurance')) {
    customElements.define('sadsloth-purchase-assurance', SadslothPurchaseAssurance);
  }
  } catch(e) { console.error(e); }
})();

})();
